import { FC } from 'react';

import { BUTTON_TYPES, ErrorIcon, EvButton, EvIcon } from '@evinced-private/ui-common';

import './ErrorState.scss';

interface IErrorStateProps {
	message: string;
	onRetry?: () => void;
}

export const ErrorState: FC<IErrorStateProps> = ({ message, onRetry }: IErrorStateProps) => {
	return (
		<div className="error-state">
			<div className="error-state-header">
				<EvIcon icon={ErrorIcon} />
				<h2>Something went wrong</h2>
			</div>
			<p>{message}</p>
			{onRetry && (
				<EvButton type={BUTTON_TYPES.PRIMARY} onClick={onRetry}>
					Try Again
				</EvButton>
			)}
		</div>
	);
};
